import { repo } from 'index';
import { useReducer } from 'react';
import { useAppContext } from 'use-app';
import get from 'lodash/get';
import assign from 'lodash/assign';
import { createReducer } from 'helpers/reducers-helper';
import { transactionTypeParams } from 'helpers/order-helper';
import { STATE_EXPORT_DISABLE, STATE_EXPORT_INIT } from 'componets/export-button/export-button';

export const SELECT_DATE_RANGE = 'SELECT_DATE_RANGE';

export const useOrderToolbar = (startAt, endAt) => {
  const initState = {
    plateNumber: undefined,
    startAt: startAt,
    endAt: endAt,
    transactionTypes: [],
    plateNumberDataSource: [],
    exportState: STATE_EXPORT_INIT,
    exportError: '',
  };

  const selectDateRange = (state, { startAt, endAt }) => {
    const exportState = startAt === undefined ? STATE_EXPORT_DISABLE : STATE_EXPORT_INIT;
    return assign({}, state, { startAt, endAt, exportState });
  };

  const reducer = createReducer(
    {
      [SELECT_DATE_RANGE]: selectDateRange,
    },
    initState
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const sendUserReport = async state => {
    const { transactionTypes, startAt, endAt, plateNumber } = state;

    await repo.sendUserReport(transactionTypeParams(transactionTypes), startAt, endAt, plateNumber);
  };

  const { state: appState } = useAppContext();
  const subAccount = get(appState, 'me.subAccount', null);
  const email = subAccount === null ? get(appState, 'me.email', '') : get(subAccount, 'email', '');

  return { state, dispatch, email, sendUserReport };
};
